var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center rounded p-4"},[_c('div',{staticClass:"text-2xl font-weight-bold"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"font-weight-light"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }